import { render } from "./registrationStep2.vue?vue&type=template&id=6f370c7a&scoped=true"
import script from "./registrationStep2.vue?vue&type=script&lang=js"
export * from "./registrationStep2.vue?vue&type=script&lang=js"

import "./registrationStep2.vue?vue&type=style&index=0&id=6f370c7a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f370c7a"]])

export default __exports__